// Sample Character Form Component - Wrapper
// This file imports and exports the working Formik-based form
import React from 'react';
import SampleCharacterFormRefactored from './SampleCharacterFormRefactored';

const SampleCharacterForm = (props) => {
  // Use the original working form with Formik
  return <SampleCharacterFormRefactored {...props} />;
};

export default SampleCharacterForm;
